function formatJetHat(did) {
    if (!did) {
        return "";
    }
    if (did.length === 10) {
        return "0"+did;
    }
    return did;
}

function replaceHtmlWithJethat(htmlContent, jetHatNumber) {
  const jethatContent =
    "<span style='font-size: 14px; font-weight: 200'><b>JetHat</b> ile extra ücret ödemeden arayın. \
        <br/>\
        <a href='tel:" + jetHatNumber + "' style='bold; color: #52ca46'>\
          <b>Hemen Ara</b>\
        </a>\
      </span>";

  return htmlContent.replace(/([+\(\)\/\-]?(\d([^a-wyzçmşığÇŞİĞ\n]|(&[a-zA-Z0-9]*;))*){9}\d{1})/ig, jethatContent);
}

function getRawNumber(phoneNumber) {
    var raw = null;
    if(phoneNumber) {
        raw = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        if(raw.length == 11) {
            raw = raw.slice(1);
        }
    }
    return raw;
}

module.exports = {
    formatJetHat: formatJetHat,
    replaceHtmlWithJethat: replaceHtmlWithJethat,
    getRawNumber: getRawNumber
}

